// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qinay","wrapperActive":"styles_wrapperActive__eRAIu","button":"styles_button__7j24G","buttonActive":"styles_buttonActive__uqJDM"};